/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import appConfig from 'src/appConfig';
import { Button, Text, View } from 'src/components/common';
import ComfirmationCodeField from 'src/components/ComfirmationCodeField';
import modalActions from 'src/redux/modal/actions';
import { IRootState } from 'src/redux/rootReducer';
import { confirmSignUpAsync, resendSignUpAsync } from 'src/redux/auth/actions';

export type EmailConfirmationModalData = {
  value?: string;
  onResend?: (...args: any) => void;
  onSubmit?: (...args: any) => void;
  onSuccess?: (...args: any) => void;
};

const EmailConfirmationModal: React.FC<Props> = ({
  error,
  isSubmittingCode,
  isResendingCode,
  modalData,
  onResend,
  onSubmit,
}) => {
  const { value: username } = modalData;

  const [code, setCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleValueChange = (value: string) => {
    setCode(value);
  };

  useEffect(() => {
    if (error) handleError(error);
  }, [error]);

  // =============================== Verify code ===============================
  useEffect(() => {
    if (code.length === appConfig.VERIFICATION_CODE_LENGTH) {
      handleSubmitCode(code);
    }
  }, [code]);

  const handleSubmitCode = (code: string) => {
    onSubmit({
      username,
      code,
    });
  };

  const handleSendAgain = () => {
    onResend({ username });
  };

  const handleError = (error: AuthError) => {
    setErrorMessage(error.message);
  };

  const buttonLabel = isSubmittingCode ? 'Verifying' : 'Send Again';

  return (
    <View className={cn('ctn-modal__content')}>
      <h3 className="mb-1">{'Verification Code'}</h3>
      <Text>Please enter the verification code sent to {username}</Text>

      <View className={cn('my-24')}>
        <ComfirmationCodeField onChange={handleValueChange} errorMessage={errorMessage} />
      </View>

      <Text className={cn('mb-8')}>{"Didn't receive the code?"}</Text>

      <View isRow justify="center">
        <Button label={buttonLabel} onClick={handleSendAgain} isLoading={isResendingCode || isSubmittingCode} />
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IRootState) => ({
  modalData: state.modal.data,
  error: state.auth.verifyError,
  isSubmittingCode: state.auth.isSubmittingCode,
  isResendingCode: state.auth.isResendingCode,
});

const mapDispatchToProps = {
  onCloseModal: modalActions.closeModal,
  onResend: resendSignUpAsync.request,
  onSubmit: confirmSignUpAsync.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailConfirmationModal);
